module.exports = __webpack_public_path__ + "img/concrete.237e6fff.png";